import axios from "axios"
import { getUrl, getErrorMessage, headers } from "../networkconfig"

const updateDemoRequest = async ({action, email, companyname, token, approvedBy, reason="" }: any) => {
  const endpoint = `updateDemoRequest`
  const url = getUrl(endpoint)

  try {
    const { data } = await axios.post(url, { action, email, companyname, approvedBy, reason } , {
      headers: {
        ...headers(),
        'x-auth-token': token,
      }
    })

    if (!data.status) return { error: "Request error" }

    return parseResponse(data)
  } catch (error) {
    return getErrorMessage(error)
  }
}

const parseResponse = (response: any) => {
  return response
}

export default updateDemoRequest